import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import ksim from '../assets/ksim-classroom-site.png';
import { useAuth } from '../auth';
import AccountLayout from '../layouts/AccountLayout';
import { useDesktop } from '../useDesktop';

const Login = () => {
  const { loginRedirect } = useAuth();
  const isDesktop = useDesktop();

  return (
    <AccountLayout>
      <Box mb={{ xs: 4, sm: 9 }} mt={{ xs: 7, sm: 15 }}>
        <Box component="img" alt="K-Sims" src={ksim} height={{ xs: 120, sm: 181 }} />
      </Box>
      <Typography component="span" variant={isDesktop ? 'h5' : 'h6'} color="text.secondary" mb={{ xs: 2, sm: 3 }}>
        K-Sim Connect
      </Typography>
      <Typography component="h1" variant={isDesktop ? 'h3' : 'h5'} mb={{ xs: 4, sm: 7 }}>
        Become a member of Kongsberg simulation community
      </Typography>

      <Box
        alignItems="center"
        display="flex"
        flexDirection={{ xs: 'column', sm: 'row' }}
        flexWrap="wrap"
        gap={2}
        justifyContent="center"
        mb={4}
      >
        <Button component={RouterLink} to="/register" variant="outlined" sx={{ flex: 1, maxWidth: '100%', width: 220 }}>
          Create account
        </Button>
        <Button onClick={loginRedirect} variant="contained" sx={{ flex: 1, maxWidth: '100%', width: 220 }}>
          Sign in
        </Button>
      </Box>
    </AccountLayout>
  );
};

export default Login;
